module.exports = __webpack_public_path__ + "static/media/Sky-Tower-Auckland-–Timing-Location-and-Things-to-Do.88dd1182.jpg";